/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AdminClaudeCredentialsRouteImport } from './routes/admin.claude-credentials'
import { Route as AdminDocsDataRouteImport } from './routes/admin.docs-data'
import { Route as CompaniesCompanyIdRouteImport } from './routes/companies.$companyId'
import { Route as CompaniesArchivesRouteImport } from './routes/companies.archives'
import { Route as CompaniesNewRouteImport } from './routes/companies.new'
import { Route as MatricesMatrixIdRouteImport } from './routes/matrices.$matrixId'
import { Route as WizardMatrixIdRouteImport } from './routes/wizard.$matrixId'
import { Route as MatricesMatrixIdExportRouteImport } from './routes/matrices.$matrixId_.export'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminClaudeCredentialsRoute = AdminClaudeCredentialsRouteImport.update({
  id: '/admin/claude-credentials',
  path: '/admin/claude-credentials',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDocsDataRoute = AdminDocsDataRouteImport.update({
  id: '/admin/docs-data',
  path: '/admin/docs-data',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesCompanyIdRoute = CompaniesCompanyIdRouteImport.update({
  id: '/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesArchivesRoute = CompaniesArchivesRouteImport.update({
  id: '/companies/archives',
  path: '/companies/archives',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesNewRoute = CompaniesNewRouteImport.update({
  id: '/companies/new',
  path: '/companies/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MatricesMatrixIdRoute = MatricesMatrixIdRouteImport.update({
  id: '/matrices/$matrixId',
  path: '/matrices/$matrixId',
  getParentRoute: () => rootRouteImport,
} as any)
const WizardMatrixIdRoute = WizardMatrixIdRouteImport.update({
  id: '/wizard/$matrixId',
  path: '/wizard/$matrixId',
  getParentRoute: () => rootRouteImport,
} as any)
const MatricesMatrixIdExportRoute = MatricesMatrixIdExportRouteImport.update({
  id: '/matrices/$matrixId_/export',
  path: '/matrices/$matrixId/export',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/admin/claude-credentials': typeof AdminClaudeCredentialsRoute
  '/admin/docs-data': typeof AdminDocsDataRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/companies/archives': typeof CompaniesArchivesRoute
  '/companies/new': typeof CompaniesNewRoute
  '/matrices/$matrixId': typeof MatricesMatrixIdRoute
  '/wizard/$matrixId': typeof WizardMatrixIdRoute
  '/matrices/$matrixId/export': typeof MatricesMatrixIdExportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/admin/claude-credentials': typeof AdminClaudeCredentialsRoute
  '/admin/docs-data': typeof AdminDocsDataRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/companies/archives': typeof CompaniesArchivesRoute
  '/companies/new': typeof CompaniesNewRoute
  '/matrices/$matrixId': typeof MatricesMatrixIdRoute
  '/wizard/$matrixId': typeof WizardMatrixIdRoute
  '/matrices/$matrixId/export': typeof MatricesMatrixIdExportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/admin/claude-credentials': typeof AdminClaudeCredentialsRoute
  '/admin/docs-data': typeof AdminDocsDataRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/companies/archives': typeof CompaniesArchivesRoute
  '/companies/new': typeof CompaniesNewRoute
  '/matrices/$matrixId': typeof MatricesMatrixIdRoute
  '/wizard/$matrixId': typeof WizardMatrixIdRoute
  '/matrices/$matrixId_/export': typeof MatricesMatrixIdExportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/settings'
    | '/admin/claude-credentials'
    | '/admin/docs-data'
    | '/companies/$companyId'
    | '/companies/archives'
    | '/companies/new'
    | '/matrices/$matrixId'
    | '/wizard/$matrixId'
    | '/matrices/$matrixId/export'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/settings'
    | '/admin/claude-credentials'
    | '/admin/docs-data'
    | '/companies/$companyId'
    | '/companies/archives'
    | '/companies/new'
    | '/matrices/$matrixId'
    | '/wizard/$matrixId'
    | '/matrices/$matrixId/export'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/settings'
    | '/admin/claude-credentials'
    | '/admin/docs-data'
    | '/companies/$companyId'
    | '/companies/archives'
    | '/companies/new'
    | '/matrices/$matrixId'
    | '/wizard/$matrixId'
    | '/matrices/$matrixId_/export'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SettingsRoute: typeof SettingsRoute
  AdminClaudeCredentialsRoute: typeof AdminClaudeCredentialsRoute
  AdminDocsDataRoute: typeof AdminDocsDataRoute
  CompaniesCompanyIdRoute: typeof CompaniesCompanyIdRoute
  CompaniesArchivesRoute: typeof CompaniesArchivesRoute
  CompaniesNewRoute: typeof CompaniesNewRoute
  MatricesMatrixIdRoute: typeof MatricesMatrixIdRoute
  WizardMatrixIdRoute: typeof WizardMatrixIdRoute
  MatricesMatrixIdExportRoute: typeof MatricesMatrixIdExportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/claude-credentials': {
      id: '/admin/claude-credentials'
      path: '/admin/claude-credentials'
      fullPath: '/admin/claude-credentials'
      preLoaderRoute: typeof AdminClaudeCredentialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/docs-data': {
      id: '/admin/docs-data'
      path: '/admin/docs-data'
      fullPath: '/admin/docs-data'
      preLoaderRoute: typeof AdminDocsDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/$companyId': {
      id: '/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof CompaniesCompanyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/archives': {
      id: '/companies/archives'
      path: '/companies/archives'
      fullPath: '/companies/archives'
      preLoaderRoute: typeof CompaniesArchivesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies/new': {
      id: '/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof CompaniesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/matrices/$matrixId': {
      id: '/matrices/$matrixId'
      path: '/matrices/$matrixId'
      fullPath: '/matrices/$matrixId'
      preLoaderRoute: typeof MatricesMatrixIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wizard/$matrixId': {
      id: '/wizard/$matrixId'
      path: '/wizard/$matrixId'
      fullPath: '/wizard/$matrixId'
      preLoaderRoute: typeof WizardMatrixIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/matrices/$matrixId_/export': {
      id: '/matrices/$matrixId_/export'
      path: '/matrices/$matrixId/export'
      fullPath: '/matrices/$matrixId/export'
      preLoaderRoute: typeof MatricesMatrixIdExportRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SettingsRoute: SettingsRoute,
  AdminClaudeCredentialsRoute: AdminClaudeCredentialsRoute,
  AdminDocsDataRoute: AdminDocsDataRoute,
  CompaniesCompanyIdRoute: CompaniesCompanyIdRoute,
  CompaniesArchivesRoute: CompaniesArchivesRoute,
  CompaniesNewRoute: CompaniesNewRoute,
  MatricesMatrixIdRoute: MatricesMatrixIdRoute,
  WizardMatrixIdRoute: WizardMatrixIdRoute,
  MatricesMatrixIdExportRoute: MatricesMatrixIdExportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
